import React from 'react';
import { MdWarning as WarningIcon } from 'react-icons/md';

const EditCurrencyCodeAlertContent = () => (
  <div>
    <div><WarningIcon /> Warning!</div>
    <div>
      Updating the Enabled Flag for a Currency Code related to enabled Company Codes
      could have negative impacts to the calculation.
    </div>
  </div>
);

export default EditCurrencyCodeAlertContent;
